import { isTouchDevice, prefersReducedMotion } from '../utils/deviceDetection';

// Base feature flags
const BASE_FEATURE_FLAGS = {
	underConstruction: false,
	backgroundMusic: true,
	cursorFollower: true,
	animations: true,
	botWidget: true,
	nowWidget: true
};

// Dynamic feature flags based on device capabilities
export const getFeatureFlags = () => {
	const isTouch = isTouchDevice();
	const reducedMotion = prefersReducedMotion();

	return {
		...BASE_FEATURE_FLAGS,
		cursorFollower: BASE_FEATURE_FLAGS.cursorFollower && !isTouch,
		animations: BASE_FEATURE_FLAGS.animations && !isTouch && !reducedMotion
	};
};

// Static export for backwards compatibility (use getFeatureFlags() for dynamic checks)
export const FEATURE_FLAGS = BASE_FEATURE_FLAGS;

export const AUDIO_CONFIG = {
	defaultVolume: 0.22,
	trackSwitchDelay: 140,
	tracks: [
		{ name: "Boombap", file: "bgboombap.mp3" },
		{ name: "Chill", file: "bgchill.mp3" },
		{ name: "Fracture", file: "bgfracture.mp3" },
		{ name: "Classic", file: "bgmusic.mp3" },
		{ name: "Synthwave", file: "bgsynthwave.mp3" }
	]
};
